import React from 'react';

const CompanySection = ({ data }) => {
  return (
    <div className="company-section">
      <div className="company-left">
        <div className="company-group">
          <div className="company-title">Shipper/Exporter</div>
          <div className="company-info">
            <div>{data.shipper.companyName}</div>
            <div>{data.shipper.address}</div>
            <div><span className="company-label">TEL:</span>{data.shipper.tel}</div>
            <div><span className="company-label">FAX:</span>{data.shipper.fax}</div>
          </div>
        </div>
        
        <div className="company-group">
          <div className="company-title">Ship to</div>
          <div className="company-info">
            <div>{data.shipTo.companyName}</div>
            <div>{data.shipTo.address}</div>
            <div><span className="company-label">ATTN:</span>{data.shipTo.attn}</div>
            <div><span className="company-label">TEL:</span>{data.shipTo.tel}</div>
          </div>
        </div>
      </div>
      
      <div className="company-middle">
        <div className="company-group">
          <div className="company-title">Terms and conditions</div>
          <div className="company-info">
            <div>Payment: {data.paymentTerms}</div>
            <div>Price: {data.termsOfPrice}</div>
          </div>
        </div>
        
        <div className="company-group">
          <div className="company-title">Contract</div>
          <div className="company-info">{data.contract}</div>
        </div>
      </div>
      
      <div className="company-right">
        <div className="company-group">
          <div className="company-title">Sold to / Bill to</div>
          <div className="company-info">
            <div>{data.soldTo.companyName}</div>
            <div>{data.soldTo.address}</div>
            <div><span className="company-label">ATTN:</span>{data.soldTo.attn}</div>
            <div><span className="company-label">TEL:</span>{data.soldTo.tel}</div>
            <div><span className="company-label">Email:</span>{data.soldTo.email}</div>
          </div>
        </div>
        
        <div className="company-group">
          <div className="company-title">Tax ID Numbers</div>
          <div className="company-info">
            <div>Ship to: {data.shipTo.taxId}</div>
            <div>Sold to: {data.soldTo.taxId}</div>
          </div>
        </div>
        
        {data.remarks && (
          <div className="company-group">
            <div className="company-title">Remark</div>
            <div className="company-info">{data.remarks}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CompanySection;